import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { KustoCopySource } from 'app/model/pipeline/copysource/kusto.copysource';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(KustoCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        database: '*',
        query: '*'
    }
})
export class KustoCopySourceAdapter extends CopySourceAdapter<KustoCopySource, Model.KustoSource> {
    protected override async _toResource(copySource: KustoCopySource): Promise<Model.KustoSource> {
        const result: Model.KustoSource = this.getCommonCopySourceProperties(
            copySource,
            Metamodel.modelFor(KustoCopySource).name
        );
        const query = ValueAdapter.toResource(copySource, KustoCopySource.READER_QUERY);
        if (query != null && query !== '') {
            result.query = query;
        }
        const database = ValueAdapter.toResource(copySource, KustoCopySource.DATABASE);
        if (database != null && database !== '') {
            result.database = database;
        }
        return result;
    }

    protected override async _toModel(
        resource: Model.KustoSource,
        copyActivity: CopyActivity
    ): Promise<KustoCopySource> {
        const result = this.createCopySourceWithCommonProperties(
            KustoCopySource.MODEL,
            resource,
            copyActivity
        ) as KustoCopySource;
        ValueAdapter.toModel(result, KustoCopySource.DATABASE, resource.database);
        result.mode = 'query'; // only support query
        if (resource.query) {
            ValueAdapter.toModel(result, KustoCopySource.READER_QUERY, resource.query);
        }
        return result;
    }
}
